import { Controller } from '@hotwired/stimulus';

const OWNER_ROLE = 'owner';

export default class extends Controller {
  static targets = ['role', 'primary', 'primaryInput', 'permissions', 'allPermissions', 'permission', 'teamMemberHint', 'ownerHint'];

  connect() {
    this.togglePrimary();
    this.togglePermissions();
  }

  roleChanged() {
    this.togglePrimary();
    this.togglePermissions();
  }

  togglePrimary() {
    if (!this.hasPrimaryTarget) return;

    const owner = this.ownerSelected;
    this.primaryTarget.hidden = !owner;
    if (this.hasPrimaryInputTarget) {
      this.primaryInputTarget.disabled = !owner;
      if (!owner) this.primaryInputTarget.checked = false;
    }
  }

  // Owners are never restricted, so choosing Owner locks every page on and
  // switching back to Team member restores what was chosen before.
  togglePermissions() {
    if (!this.hasPermissionsTarget) return;

    const owner = this.ownerSelected;
    this.permissionTargets.forEach((input) => {
      if (owner) {
        if (input.dataset.savedChecked === undefined) input.dataset.savedChecked = input.checked;
        input.checked = true;
      } else if (input.dataset.savedChecked !== undefined) {
        input.checked = input.dataset.savedChecked === 'true';
        delete input.dataset.savedChecked;
      }
      input.disabled = owner;
    });
    if (this.hasAllPermissionsTarget) this.allPermissionsTarget.disabled = owner;
    if (this.hasTeamMemberHintTarget) this.teamMemberHintTarget.hidden = owner;
    if (this.hasOwnerHintTarget) this.ownerHintTarget.hidden = !owner;
    this.syncAllPermissions();
  }

  toggleAllPermissions(event) {
    this.permissionTargets.forEach((input) => {
      input.checked = event.target.checked;
    });
  }

  permissionChanged() {
    this.syncAllPermissions();
  }

  syncAllPermissions() {
    if (!this.hasAllPermissionsTarget) return;

    this.allPermissionsTarget.checked = this.permissionTargets.every((input) => input.checked);
  }

  // Matched on the radio's data-role-name (the Role record's name) rather than
  // its label, which could be retitled.
  get ownerSelected() {
    return this.roleTarget.querySelector('input[type="radio"]:checked')?.dataset.roleName === OWNER_ROLE;
  }
}
